import React from 'react';
import './style.scss';
import { TextField } from '@mui/material';

function TextInput({onChange, value, className,onClick, id, type, label, placeholder, style={}, error=false}) {
    let customStyle = style;
    let baseClass = 'TextInput';
    if (error){
        baseClass = 'TextInputError';
    };

    return (
        <TextField  onClick={onClick} className={`${baseClass} ${className}`} id={id} type={type} label={label} variant="standard" placeholder={placeholder} value={value} onChange={onChange} style={style}/>
    ) 
}


export default TextInput;